import { OrderBy, OrderDirection } from '@models/requestFilters';
import { httpGet } from './apiService';
import { EntityAdminApiService } from './entityAdminApiService';
import { PagedResult } from '@models/pagination';

export abstract class LanguageEntityAdminApiService<Entity> extends EntityAdminApiService<Entity> {
    private readonly slugEntity: boolean;

    constructor(baseUrl: string, slugEntityAdminApiServiceClass = false) {
        super(baseUrl);
        this.slugEntity = slugEntityAdminApiServiceClass;
    }

    public async get(
        pageNumber: number,
        rowsPerPage: number,
        languageId: number,
        orderBy?: OrderBy,
        orderDirection?: OrderDirection
    ): Promise<PagedResult<Entity> | undefined> {
        const response = await httpGet(
            `${this.baseUrl}/paged/${languageId}/${pageNumber + 1}/${rowsPerPage}/${this.getOrderByString(
                orderBy,
                orderDirection
            )}`
        );

        return this.returnResult(await response.json());
    }

    public async getAll(languageId: number, orderBy?: OrderBy, orderDirection?: OrderDirection): Promise<Entity[]> {
        let orderByParam = '';

        if (this.slugEntity) {
            orderByParam = `/${this.getOrderByString(orderBy, orderDirection)}`;
        }

        const response = await httpGet(`${this.baseUrl}/all/${languageId}${orderByParam}`);

        return this.returnArrayResult(await response.json());
    }

    public async getSearchedList(
        pageNumber: number,
        rowsPerPage: number,
        languageId: number,
        searchTerm: string,
        orderBy?: OrderBy,
        orderDirection?: OrderDirection
    ): Promise<PagedResult<Entity> | undefined> {
        const response = await httpGet(
            `${this.baseUrl}/search/paged/${languageId}/${pageNumber + 1}/${rowsPerPage}/${encodeURIComponent(
                searchTerm
            )}/${this.getOrderByString(orderBy, orderDirection)}`
        );

        return this.returnResult(await response.json());
    }
}
